import React, { useState } from "react";
import axios from "axios";
import "./Photo.css";

let pexelsKey = process.env.REACT_APP_PEXELS_KEY;

export default function Photo(props) {
  let [photos, setPhotos] = useState(null);

  function handleResponse(response) {
    setPhotos(response.data.photos);
  }

  function handleError() {
    setPhotos([]);
  }

  if (photos) {
    if (photos.length === 0) {
      return null;
    }

    return (
      <div className="Photo-card">
        <div className="Photo-grid">
          {photos.map((photo) => (
            <a
              key={photo.id}
              href={photo.url}
              target="_blank"
              rel="noopener noreferrer"
              className="Photo-item"
            >
              <img
                src={photo.src.medium}
                alt={photo.alt || props.keyword}
                className="Photo-image"
              />
              <span className="Photo-item-credit">{photo.photographer}</span>
            </a>
          ))}
        </div>
        <p className="Photo-credit">
          Foto fornite da{" "}
          <a
            href="https://www.pexels.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pexels
          </a>
        </p>
      </div>
    );
  } else {
    let url = `https://api.pexels.com/v1/search?query=${props.keyword}&per_page=4`;
    axios
      .get(url, { headers: { Authorization: pexelsKey } })
      .then(handleResponse)
      .catch(handleError);
    return null;
  }
}
